import React from 'react'

import { Wrap } from './styles'
import enhance from './enhance'
import { range } from './utils'
import DefaultScoreIcon from './DefaultScoreIcon'

const InputScore = ({
  Icon = DefaultScoreIcon,
  count = 5,
  handleSelect,
  handleHover,
  handleHoverEnds,
  selectedValue,
  hoverValue,
  isHovering,
  ...rest
}) => (
  <Wrap onMouseLeave={handleHoverEnds} data-testid={rest['data-testid']}>
    {range(1, count + 1).map((value, index) => (
      <Icon
        key={index}
        id={`input-score-${value}`}
        onClick={() => handleSelect(value)}
        onMouseOver={() => handleHover(value)}
        active={isHovering ? value <= hoverValue : value <= selectedValue}
      />
    ))}
  </Wrap>
)

export default enhance(InputScore)
